import { callApi } from '@local_modules/generic/fetch.js'
import { setElementHtml } from '../../../../../helpers/generic-js/dom.js'
import { makeOne } from './make-one.js'

export async function showInviteList (params) {
  console.log('showInviteList')
  const { browserAppAccount, list } = params
  const { containerElementId } = list

  const invitations = await loadList(browserAppAccount)

  const containerElement = setElementHtml(containerElementId, '')

  invitations?.forEach(function (oneInvite) {
    const inviteElement = makeOne(oneInvite)
    containerElement.appendChild(inviteElement)
  })

  // const containerElement = setElementHtml(containerElementId, invitationsHtml)

  if (!invitations || invitations.length === 0) {
    containerElement.innerHTML = '<div class="notification is-info">There are no ongoing invitations</div>'
  }
}

async function loadList (browserAppAccount) {
  const apiUrl = '/api/user-invites/list/byaccount/:appAccountId'

  const data = await callApi(apiUrl, {
    appAccountId: browserAppAccount.data.appAccountId
  })
  console.log('invites', data)
  return data
}
